// src/graphql/mutations/storageMutations.js

export const adminClearEvidenceCache = `mutation AdminClearEvidenceCache($documentId: String!, $assessmentId: String!) {
    adminClearEvidenceCache(documentId: $documentId, assessmentId: $assessmentId) {
        success
        filesDeleted
        bytesFreed
        error
    }
}`;

export const adminClearAssessmentEvidenceCache = `mutation AdminClearAssessmentEvidenceCache($assessmentId: String!) {
    adminClearAssessmentEvidenceCache(assessmentId: $assessmentId) {
        success
        filesDeleted
        bytesFreed
        error
    }
}`;

export const adminRegenerateEvidenceImages = `mutation AdminRegenerateEvidenceImages($documentId: String!, $assessmentId: String!) {
    adminRegenerateEvidenceImages(documentId: $documentId, assessmentId: $assessmentId) {
        success
        snippetsGenerated
        fullPagesGenerated
        processingTimeMs
        error
    }
}`;

export const adminCleanupOrphanedFiles = `mutation AdminCleanupOrphanedFiles($dryRun: Boolean) {
    adminCleanupOrphanedFiles(dryRun: $dryRun) {
        success
        dryRun
        filesFound
        filesDeleted
        bytesFreed
        errors
    }
}`;

export const adminVerifyDocumentStorage = `mutation AdminVerifyDocumentStorage($tenderId: String!, $repair: Boolean) {
    adminVerifyDocumentStorage(tenderId: $tenderId, repair: $repair) {
        success
        tenderId
        totalDocuments
        verifiedCount
        issuesFound
        repairedCount
        details {
            documentId
            documentTitle
            status
            originalExists
            pdfExists
            message
        }
        error
    }
}`;

export const adminListTenderDocuments = `mutation AdminListTenderDocuments($tenderId: String!) {
    adminListTenderDocuments(tenderId: $tenderId) {
        success
        tenderId
        documents {
            id
            title
            fileType
            fileSize
            sourceUrl
            storageKey
            pdfStorageKey
            isConverted
            documentState
            createdAt
            originalExists
            pdfExists
        }
        totalCount
        totalStorageBytes
        error
    }
}`;

export const adminDeleteDocument = `mutation AdminDeleteDocument($documentId: String!) {
    adminDeleteDocument(documentId: $documentId) {
        success
        documentId
        documentTitle
        filesDeleted
        snippetsCleaned
        bytesFreed
        error
    }
}`;

export const adminDeleteAllTenderDocuments = `mutation AdminDeleteAllTenderDocuments($tenderId: String!, $dryRun: Boolean) {
    adminDeleteAllTenderDocuments(tenderId: $tenderId, dryRun: $dryRun) {
        success
        dryRun
        tenderId
        documentsDeleted
        filesDeleted
        snippetsCleaned
        bytesFreed
        errors
    }
}`;
